import React from 'react';

const ManageProduct = () => {
    return (
        <div>
            <h1> manage product</h1>
        </div>
    );
};

export default ManageProduct;